import type { BoggleUnviewedWord, BoggleWordStat } from '~/boggle/progress/types'

export type LexiconHubSession = {
  sessionNewWords: readonly BoggleUnviewedWord[]
  wordStats: BoggleWordStat[]
}

type LexiconHubRepository = {
  getUnviewedWords(): Promise<BoggleUnviewedWord[]>
  getWordStats(): Promise<BoggleWordStat[]>
}

/** Loads lexicon projections and snapshots durable unviewed words (acknowledge separately). */
export async function bootstrapLexiconHubSession(
  repository: LexiconHubRepository,
): Promise<LexiconHubSession> {
  const [wordStats, sessionNewWords] = await Promise.all([
    repository.getWordStats(),
    repository.getUnviewedWords(),
  ])
  return { sessionNewWords, wordStats }
}
